import styled from 'styled-components'

export const SubHeaderWrapper = styled.div`
	font-size: var(--fs-xl);
	max-width: 80%;
	text-align: center;
	margin: var(--mg-sm) 0px;
	color: var(--btn-color);
`

export const SubHeaderText = styled.div`
	font-size: var(--fs-xl);
`
